export default __webpack_public_path__ + "static/media/collagen@3x.42d399c2.jpg";